import { ApplicationError, ErrorType } from '../types'

export class GitHubUrl {
	static async getSHAFromLatestCommit(repoUrl: string) {
		if (!repoUrl) {
			return {
				error: new ApplicationError({
					type: ErrorType.InvalidInput,
					message: 'The repository URL is required.',
					code: 'invalid_github_url'
				})
			}
		}

		const githubUrlRegex =
			/^https:\/\/(?:www\.)?github\.com\/([\w-]+)\/([\w-]+)(?:\.git)?$/

		if (!githubUrlRegex.test(repoUrl)) {
			return {
				error: new ApplicationError({
					type: ErrorType.InvalidInput,
					message: 'The provided URL is not a valid GitHub URL.',
					code: 'invalid_github_url'
				})
			}
		}

		try {
			const url = new URL(repoUrl)
			const pathParts = url.pathname.split('/')
			const owner = pathParts[1]
			const repo = pathParts[2]!.replace(/\.git$/, '') // Removes '.git' if present
			const response = await fetch(
				`https://api.github.com/repos/${owner}/${repo}/commits`
			)

			if (!response.ok) {
				if (response.status === 404) {
					return {
						error: new ApplicationError({
							type: ErrorType.NotFound,
							message:
								'We could not find the repository. Please check if the repository is public.',
							code: 'github_url_not_found'
						})
					}
				}

				if (response.status === 409) {
					return {
						error: new ApplicationError({
							type: ErrorType.InvalidInput,
							message: 'The Git repository is empty.',
							code: 'github_repo_empty'
						})
					}
				}

				return {
					error: new ApplicationError({
						type: ErrorType.BadRequest,
						message: `Error ${response.status}: ${response.statusText}`,
						code: 'github_bad_request'
					})
				}
			}

			const commits: {
				sha: string
			}[] = await response.json()

			if (commits.length === 0) {
				return {
					error: new ApplicationError({
						type: ErrorType.InvalidInput,
						message: 'The repository does not have any commits.',
						code: 'github_no_commits'
					})
				}
			}

			if (commits[0]?.sha) {
				return { shaLatestCommit: commits[0].sha }
			}

			return {
				error: new ApplicationError({
					type: ErrorType.Unknown,
					message: 'Could not retrieve the first commit SHA.',
					code: 'github_commit_sha_error'
				})
			}
		} catch (error) {
			return {
				error: new ApplicationError({
					type: ErrorType.Unknown,
					message:
						'Something went wrong while checking the repository. Please try again.',
					code: 'unknown_error'
				})
			}
		}
	}
}
